// src/components/BookCover/CollaboratePanel.jsx
// Collaborate tab panel — left-side toolbar with quick-access buttons.
// Clicking a button switches the corresponding tab in the right sidebar
// (CoverRightSidebar). No inline forms — those now live in the sidebar tabs.

import React from 'react';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AddCommentIcon from '@mui/icons-material/AddComment';
import GroupIcon from '@mui/icons-material/Group';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import HistoryIcon from '@mui/icons-material/History';
import '../../styles/CollaboratePanel.css';

/**
 * CollaboratePanel
 * ----------------
 * Left-side toolbar panel (below the tab bar). Contains buttons that drive
 * which tab is shown in the right-side CoverRightSidebar.
 *
 * Props:
 *  - collabSideView / setCollabSideView — controls which right sidebar tab activates
 */
export default function CollaboratePanel({
  collabSideView,
  setCollabSideView,
  onInvite,
}) {
  const toggleSideView = (view) => {
    setCollabSideView(prev => prev === view ? null : view);
  };

  return (
    <div className="collab-panel">
      <div className="collab-grid">
        {/* Actions card */}
        <div className="collab-card">
          <div className="collab-card-header">
            <span className="collab-card-icon">⚡</span>
            <span className="collab-card-title">Actions</span>
          </div>
          <div className="collab-card-body">
            <button
              className={`collab-btn collab-btn--invite${collabSideView === 'collaborators' ? ' collab-btn--active' : ''}`}
              onClick={() => { toggleSideView('collaborators'); onInvite?.(); }}
              title="Invite a collaborator"
            >
              <PersonAddIcon style={{ fontSize: 16 }} />
              <span>New Request</span>
            </button>
            <button
              className={`collab-btn collab-btn--comment${collabSideView === 'comments' ? ' collab-btn--active' : ''}`}
              onClick={() => toggleSideView('comments')}
              title="Add a comment (opens Chat tab)"
            >
              <AddCommentIcon style={{ fontSize: 16 }} />
              <span>Add Comment</span>
            </button>
          </div>
        </div>

        {/* Views card */}
        <div className="collab-card">
          <div className="collab-card-header">
            <span className="collab-card-icon">👁️</span>
            <span className="collab-card-title">View</span>
          </div>
          <div className="collab-card-body">
            <button
              className={`collab-btn collab-btn--outline${collabSideView === 'collaborators' ? ' collab-btn--active' : ''}`}
              onClick={() => toggleSideView('collaborators')}
              title="View collaborators"
            >
              <GroupIcon style={{ fontSize: 16 }} />
              <span>Collaborators</span>
            </button>
            <button
              className={`collab-btn collab-btn--outline${collabSideView === 'comments' ? ' collab-btn--active' : ''}`}
              onClick={() => toggleSideView('comments')}
              title="View comments"
            >
              <ChatBubbleOutlineIcon style={{ fontSize: 16 }} />
              <span>Comments</span>
            </button>
            <button
              className={`collab-btn collab-btn--outline${collabSideView === 'changes' ? ' collab-btn--active' : ''}`}
              onClick={() => toggleSideView('changes')}
              title="View activity & changes"
            >
              <HistoryIcon style={{ fontSize: 16 }} />
              <span>Activity</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
